"use client";

import { CallStatus } from "@prisma/client";
import Badge from "@/app/(components)/generics/Badge/Badge";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { UStyles } from "@/app/utils/UStyles";
import { CALL_STATUS_MAP } from "../../CallAnalysis.logic";
import styles from "./CallStatusBadge.module.css";

type Props = {
  status?: CallStatus;
  lang: string;
};

export default function CallStatusBadge({ status }: Props) {
  const T = useT();
  const config = status
    ? CALL_STATUS_MAP[status]
    : { key: TKey.CALL_ANALYSIS_STATUS_UPLOADING, cssClass: "statusProcessing" };

  if (!config) return null;

  return (
    <Badge className={UStyles.classNames(styles.statusBadge, styles[config.cssClass])}>
      {T(config.key)}
    </Badge>
  );
}
